import { DataService } from "./data-service";
import { IImportValidationStatus, IImportValidationSuccessStatus } from "../entities/import-bzs";

class ImportBzsConfigurationV2Service extends DataService {
    constructor() {
        super("import-bzs", 2);
    }

    upload(file: File): Promise<IImportValidationSuccessStatus | IImportValidationStatus[]> {
        const formData = new FormData();
        formData.append("bZs", file);

        return this.api.post<IImportValidationSuccessStatus | IImportValidationStatus[]>(null, formData);
    }
}

export const importBzsConfigurationV2Service = new ImportBzsConfigurationV2Service();
